module.exports = __webpack_public_path__ + "static/img/4层.75b0590.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/4层.png
// module id = YGoN
// module chunks = 0